import { useUserOrganization } from '@modules-deprecated/app/organization'

import { CountryIsoCode } from '../../../../../types/countryIsoCode'

const COUNTRIES_TO_USE_TEMPLATES: CountryIsoCode[] = ['dk', 'fr', 'nl', 'de']

export const useTemplatesToCreateVatRates = () => {
  const { organization } = useUserOrganization()
  const countryIsoCode = organization?.countryId.toLowerCase() as CountryIsoCode | undefined

  return {
    isCreateNewVatRateFromTemplate: Boolean(countryIsoCode && COUNTRIES_TO_USE_TEMPLATES.includes(countryIsoCode)),
  }
}
